import { resolveRates } from './ncfFinancials.mjs';

export const PROJECT_CHANGE_REASON = "Consultant's change of project/client/location";
export const JOB_DATE_PATHS = ['assignment.jobStartDate', 'assignment.jobEndDate'];
export const CHANGE_SYSTEM_PATHS = new Set(['ncf.submissionReason', 'ncf.submittedDate', 'ncf.submittedBy', 'ncf.effectiveDate', 'ncf.financialReview']);
export const getValue = (root, path) => String(path).replace(/\[(\d+)\]/g, '.$1').split('.')
  .reduce((value, key) => value?.[key], root);
export const isMissingChangeValue = (field, value) => {
  const text = String(value ?? '').trim();
  return !text || /^select(?:\.\.\.|…)$/i.test(text)
    || ((field.format === 'date' || JOB_DATE_PATHS.includes(field.sourcePath)) && Number.isNaN(Date.parse(text)));
};

// Reviewed values are explicit edits: a blank must not resurrect an old job's data.
export const applyReviewedValues = (target, source) => {
  if (!source || typeof source !== 'object') return target;
  Object.entries(source).forEach(([key, value]) => {
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      if (!target[key] || typeof target[key] !== 'object' || Array.isArray(target[key])) target[key] = {};
      applyReviewedValues(target[key], value);
    } else {
      target[key] = structuredClone(value);
    }
  });
  return target;
};

export const buildJobChangeValues = (job, submittal, fields) => {
  const rates = resolveRates(fields);
  const assignment = {
    clientName: job.company,
    jobTitle: job.title,
    jobReference: job.reference || String(job.id),
    jobLocation: job.location || job.jobLocation,
    jobStartDate: submittal?.startDate || job.startDate,
    desiredStartDate: submittal?.startDate || job.startDate,
    jobEndDate: job.endDate,
    payRate: submittal?.agreedPayRate ?? job.payRate,
    payRateType: job.payRateType
  };
  const root = { assignment, jobdiva: { job, submittal: submittal || {} } };
  const values = Object.fromEntries([
    ...Object.keys(assignment).map(key => [`assignment.${key}`, assignment[key] ?? '']),
    ...fields.filter(field => /^(jobdiva\.job\.|jobdiva\.submittal\.)/.test(field.sourcePath))
      .map(field => [field.sourcePath, getValue(root, field.sourcePath) ?? ''])
  ]);
  const rateValues = {
    pay: submittal?.agreedPayRate ?? job.payRate,
    bill: submittal?.agreedBillRate ?? job.billRate,
    otPay: job.otPayRate,
    otBill: job.otBillRate
  };
  Object.entries(rates).forEach(([kind, path]) => { values[path] = rateValues[kind] ?? ''; });
  return values;
};

export const getJobChangeRequiredFields = fields => [
  { sourcePath: resolveRates(fields).pay, label: 'Pay Rate', format: 'currency' },
  { sourcePath: 'assignment.payRateType', label: 'Pay Rate Frequency', format: 'text' },
  { sourcePath: 'assignment.jobStartDate', label: 'Job Start Date', format: 'date' }
].map(field => ({ fieldGroup: 'Client / Project Information', ...fields.find(item => item.sourcePath === field.sourcePath), ...field, isRequired: true }));
